<template>
  <div class="container mt-4">
    <div class="card p-4 shadow border-0">
      <h4 class="mb-4" style="color:#b03a45;">
        <i class="material-icons-round me-2" style="color:#b03a45;">folder</i>
        {{ $t("employeedocuments.title") }}
      </h4>

      <!-- LOADING -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border text-danger"></div>
        <div class="mt-2 text-muted">
          {{ $t("employeedocuments.loading") }}
        </div>
      </div>

      <!-- EMPTY -->
      <div v-else-if="documents.length === 0" class="text-center text-muted">
        {{ $t("employeedocuments.empty") }}
      </div>

      <!-- TABLE -->
      <div v-else>
        <table class="table table-bordered">
          <thead class="table-light">
            <tr>
              <th>{{ $t("employeedocuments.table.title") }}</th>
              <th>{{ $t("employeedocuments.table.type") }}</th>
              <th>{{ $t("employeedocuments.table.file") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="doc in documents" :key="doc.id">
              <td>{{ doc.title || '-' }}</td>
              <td>{{ doc.type?.name }}</td>
              <td>
                <a
                  :href="fileUrl(doc.file_path)"
                  target="_blank"
                  class="btn btn-sm"
                  style="background-color:#b03a45; color:white; border:none;"
                >
                  {{ $t("employeedocuments.table.view") }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "@/api";

export default {
  name: "DocumentsEmployee",

  data() {
    return {
      documents: [],
      loading: true,
    };
  },

  methods: {
    fileUrl(path) {
      return `${process.env.VUE_APP_API_URL}/storage/${path}`;
    }
  },

  async mounted() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const response = await axios.get(`/employee/documents/${user.id}`);
      this.documents = response.data.data;
    } catch (err) {
      console.error("DOCUMENT ERROR:", err);
      this.documents = [];
    } finally {
      this.loading = false;
    }
  },
};
</script>
